import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { AppDispatch, RootState } from 'app/store';
import { ISubscription, IAddUpdateSubscriptionData, SubscriptionStatus } from './subscriptionTypes';
import { fetchSubscriptionByOrganozationId, changeSubscriptionInfo, addNewSubscription, cancelSubscriptionById, reactivateSubscriptionById, fetchSubscriptionById } from 'api/billing/subscriptions';
import { toast } from 'react-toastify';

export const setSubscriptionInfo = createAction<ISubscription>('@subscription/setSubscriptionInfo');

export const getSubscriptionInfoByOrganozationId = createAsyncThunk<
  ISubscription,
  number,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/getSubscriptionInfoByOrganozationId', async (organozationId, thunkApi) => {
  try {
    const res = await fetchSubscriptionByOrganozationId(organozationId);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const getSubscriptionInfoById = createAsyncThunk<
  ISubscription,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/getSubscriptionInfoById', async (subscriptionId, thunkApi) => {
  try {
    const res = await fetchSubscriptionById(subscriptionId);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const updateSubscriptionInfo = createAsyncThunk<
  ISubscription,
  IAddUpdateSubscriptionData,
  {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/updateSubscriptionInfo', async (data, thunkApi) => {
  try {
    const res = await changeSubscriptionInfo(data);
    if (res.data.status !== SubscriptionStatus.PastDue) {
      toast.success('Subscription updated')
    }
    return res.data
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const addSubscription = createAsyncThunk<
  ISubscription,
  { organizationId: number; model: IAddUpdateSubscriptionData },
  {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/addNewSubscription', async ({ organizationId, model }, thunkApi) => {
  try {
    const res = await addNewSubscription(organizationId, model);
    toast.success('Subscription created')
    return res.data
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const cancelSubscription = createAsyncThunk<
  ISubscription,
  string,
  {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/cancelSubscription', async (subscriptionId, thunkApi) => {
  try {
    const res = await cancelSubscriptionById(subscriptionId);
    toast.success('Subscription canceled')
    return res.data
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const reactivateSubscription = createAsyncThunk<
  ISubscription,
  string,
  {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@subscription/reactivateSubscription', async (subscriptionId, thunkApi) => {
  try {
    const res = await reactivateSubscriptionById(subscriptionId);
    toast.success('Subscription reactivated')
    return res.data
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
